var style = {"displayInlineFlex":"FlexboxContainer-module_displayInlineFlex__6MOuJ","displayFlex":"FlexboxContainer-module_displayFlex__7s0cJ"};

export { style as default };
//# sourceMappingURL=FlexboxContainer.module.scss.js.map
